'use client'

import React, { ReactElement } from 'react'
import { ContextMenuItem } from '../../../../molecules'
import { CheckmarkSmallIcon, IconSizes } from '../../../../icons'
import { BaseButtonProps } from '../../../../atoms'

export interface ContextMenuSelectFilterOptionProps extends BaseButtonProps {
    isSelected: boolean
}

export const ContextMenuSelectFilterOption = ({
    children,
    isSelected,
    ...props
}: ContextMenuSelectFilterOptionProps): ReactElement => {
    return (
        <ContextMenuItem
            {...props}
            icon={
                isSelected && (
                    <CheckmarkSmallIcon strokeWidth={2} size={IconSizes.MEDIUM} className="text-text-interactive" />
                )
            }
        >
            {children}
        </ContextMenuItem>
    )
}
